module.exports = "<div class=btn-group><label ng-repeat=\"element in $ctrl.elements track by element.id\" ng-model=$ctrl.selected ng-change=::$ctrl.valueSelected(element.id) uib-btn-radio=::element.id uib-tooltip={{::element.tooltip}} tooltip-append-to-body=true ng-bind=::element.content></label></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common/widgets/switcher/switcher.html
// module id = 802
// module chunks = 0